import { GlobalStyles, Stack } from '@mui/material';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    environment: process.env.REACT_APP_ENABLE_ENV || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Sentry Event:', event);
        console.error('Sentry Hint:', hint);
      }
      return event;
    },
  });

  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event.reason, {
      contexts: {
        unhandledRejection: {
          reason: event.reason,
        },
      },
    });
  });

  window.addEventListener('error', (event) => {
    Sentry.captureException(event.error || event.message, {
      contexts: {
        error: {
          message: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        },
      },
    });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <GlobalStyles
      styles={{
        ":root": { "--screen-height": `${window.innerHeight}px` },
        "#root": {
          position: "relative",
          minHeight: "var(--screen-height)",
        },
      }}
    />
    <Suspense
      fallback={
        <Stack height="var(--screen-height)" justifyContent="center" alignItems="center">
          Đang tải... / Loading...
        </Stack>
      }
    >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Suspense>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
